import { useState } from "react";
import { Upload, Archive } from "lucide-react";
import { toast } from "sonner";
import { API, api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const StorePublish = ({ guide, onChange }) => {
  const [busy, setBusy] = useState(false);
  const act = async (path, published, msg) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/guides/${guide.id}/store/${path}`);
      onChange({ published, store_sync: data });
      toast.success(msg);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  const sync = guide.store_sync;
  return (
    <div className="flex flex-col items-end gap-1.5">
      {guide.published ? (
        <Button variant="outline" data-testid="store-unpublish-button" disabled={busy} onClick={() => act("unpublish", false, "Removed from theexpatstudio.com")} className="rounded-none">
          <Archive className="w-4 h-4 mr-2" />{busy ? "Removing…" : "Unpublish from store"}
        </Button>
      ) : (
        <Button data-testid="store-publish-button" disabled={busy} onClick={() => act("publish", true, "Published to theexpatstudio.com")} className="rounded-none">
          <Upload className="w-4 h-4 mr-2" />{busy ? "Publishing…" : "Publish to theexpatstudio.com"}
        </Button>
      )}
      <span data-testid="store-sync-status" className={`text-[11px] ${guide.published ? "text-[#2D6A4F]" : "text-[#8C827A]"}`}>
        {guide.published ? `In the shop catalogue · Edition ${guide.edition || 1}` : "Not in the shop catalogue yet"}
        {sync && !sync.ok && sync.status_code && sync.status_code !== 405 ? ` · last direct push failed (${sync.status_code})` : ""}
      </span>
      {guide.published && (
        <a data-testid="public-changelog-link" href={`${API}/public/guides/${slug(guide.town)}/changelog.html`} target="_blank" rel="noreferrer" className="text-[11px] text-[var(--g-dark2,#4A1E5C)] hover:text-[var(--g-accent,#C59B27)]">Public "what's new" page ↗</a>
      )}
    </div>
  );
};
